import { indexedDbAvailable } from "@/db/indexedDbAvailable.ts";

const bootstrapRegistryName = "sbweb-bootstrap-registry";
const pgLitePrefix = "/pglite/";

export const fetchInvalidDbList = async (version: string): Promise<string[]> => {
  if (!indexedDbAvailable() || !indexedDB.databases) {
    return [];
  }
  const validDBVersion = `${pgLitePrefix}${version}-`;
  try {
    const databases = await indexedDB.databases();

    return (
      databases
        ?.map((db) => db.name)
        ?.filter(
          (name) =>
            name?.includes(bootstrapRegistryName) || name?.includes(pgLitePrefix) || name?.includes("--remove-db---"),
        )
        ?.filter((name) => !name?.includes(validDBVersion))
        ?.filter((name): name is string => {
          if (name?.includes("--remove-db---")) {
            return true;
          }
          if (name?.includes(pgLitePrefix)) {
            return true;
          } else if (name?.includes(bootstrapRegistryName) && !name?.includes(`${version}-`)) {
            return true;
          }
          return false;
        }) ?? []
    );
  } catch (error) {
    console.error("Error listing IndexedDB databases:", error);
    return [];
  }
};

const deleteIndexedDB = async (name: string): Promise<string> => {
  if (!indexedDbAvailable()) {
    return `Database '${name}' skipped — IndexedDB unavailable.`;
  }
  return new Promise((resolve, reject) => {
    const request = indexedDB.deleteDatabase(name);
    request.onsuccess = () => {
      resolve(`Database '${name}' deleted successfully.`);
    };
    request.onerror = () => {
      reject(`Database error deleting "${name}".`);
    };
    request.onblocked = () => {
      reject(`Database error deleting "${name}".`);
    };
  });
};

export const cleanupDBs = async (version: string): Promise<number> => {
  const invalidDBs = await fetchInvalidDbList(version);
  if (invalidDBs.length > 0) {
    for (const db of invalidDBs) {
      try {
        await deleteIndexedDB(db);
      } catch (e) {
        console.error(e);
      }
    }
  }
  return invalidDBs.length;
};
